'use client';

/** Aynı URL/anahtar için eşzamanlı client fetch'leri tek isteğe indirir (Strict Mode / çoklu mount). */
const inflight = new Map<string, Promise<unknown>>();

export function clientFetchDedupe<T>(cacheKey: string, fetcher: () => Promise<T>): Promise<T> {
  const existing = inflight.get(cacheKey);
  if (existing) {
    return existing as Promise<T>;
  }
  const promise = fetcher().finally(() => {
    inflight.delete(cacheKey);
  });
  inflight.set(cacheKey, promise);
  return promise;
}

export async function clientFetchJsonDedupe<T>(
  cacheKey: string,
  url: string,
  init?: RequestInit,
): Promise<T> {
  return clientFetchDedupe(cacheKey, async () => {
    const res = await fetch(url, init);
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}: ${url}`);
    }
    return (await res.json()) as T;
  });
}
